import React from 'react';
import TicketErrorText from './TicketErrorText';
import TicketStateBase from '../TicketStateBase';
import ErrorBear from '../../../assets/bearError.svg';
import { useLocation } from 'react-router-dom';

const TicketError = () => {
  const location = useLocation();

  return (
    <TicketStateBase
      mobile={location.state.mobile}
      texts={<TicketErrorText />}
      image={ErrorBear}
      returnText="Volver al menú"
      simpleText="Ir a ripley.com"
    />
  );
};

export default TicketError;
